import { addToCartDone, addSailplayDiscount } from '../cart/actions';
import * as types from './actionTypes';
import cartApi from '../cart/api';
import sailplayApi from './api';
import { maxCashbackCanUseSelector } from '../pricing/selectors';

export const activateBonusesUsage = payload => ({ type: types.ACTIVATE_BONUSES_USAGE, payload });
export const cancelBonusesUsage = () => ({ type: types.ACTIVATE_BONUSES_USAGE, payload: 0 });

export const setAllowedNumberBonuses = () => {
  return (dispatch, getState) => {
    const state = getState();
    const maxBonusesCanUse = maxCashbackCanUseSelector(state);
    const usedBonuses = state.cart?.sailplay_discount;

    if (maxBonusesCanUse > 0 && usedBonuses > maxBonusesCanUse) {
      dispatch(addSailplayDiscount(maxBonusesCanUse));
      return dispatch(activateBonusesUsage(maxBonusesCanUse));
    }

    if (maxBonusesCanUse <= 0 && usedBonuses !== 0) {
      dispatch(addSailplayDiscount(0));
      return dispatch(activateBonusesUsage(0));
    }

    return null;
  };
};

export const fetchGifts = () => {
  return dispatch => {
    dispatch({ type: types.FETCH_GIFTS_REQUEST });

    return sailplayApi
      .getGifts()
      .then(data => {
        return dispatch({ type: types.FETCH_GIFTS_SUCCESS, payload: data });
      })
      .catch(({ message }) => {
        return dispatch({ type: types.FETCH_GIFTS_FAILURE, payload: message });
      });
  };
};

export const fetchGiftsIsNeeded = () => {
  return (dispatch, getState) => {
    const {
      sailplay: {
        gifts: { isLoading, isLoaded },
      },
    } = getState();

    if (!isLoading && !isLoaded) {
      return dispatch(fetchGifts());
    }

    return false;
  };
};

export const addToCart = (id, composition) => {
  return dispatch => {
    dispatch({ type: types.ADD_TO_CART_REQUEST });

    return cartApi
      .addToCart(composition)
      .then(data => {
        return dispatch(addToCartDone(data));
      })
      .catch(({ message }) => {
        return { type: types.ADD_TO_CART_FAILURE, payload: message };
      });
  };
};
